import {useSelector} from '../../store.js'
import HeaderDropdown from '../../common/components/List/HeaderDropdown.js'
import DropdownItemButton from '../../common/components/Dropdown/DropdownItemButton.js'
import {showCreateProductModal} from './Modals/CreateProductModal.js'
import {
  showCartSyncModal,
  allowCartSyncModalSelector,
} from '../Modals/CartSyncModal/cartSyncModalFunctions.js'
import {showCreateInventoryTransferModal} from '../TransferListPage/Modals/CreateInventoryTransferModal/createInventoryTransferModalFunctions.js'
import {
  hasMOPermissionSelector,
  hasProductImportFromCartPermissionSelector,
  hasProductManageTagPermissionSelector,
} from '../../data/me.js'
import {showEditReportModal} from '../ReportsPage/Modals/EditReportModal.js'
import {
  REPORT_EXPORT_INVENTORY_SNAPSHOT,
  REPORT_EXPORT_PRODUCTS_INVENTORY,
  REPORT_EXPORT_PRODUCTS_NO_INVENTORY,
  REPORT_EXPORT_PRODUCTS_FULFILLMENT_SPEED,
  REPORT_EXPORT_PRODUCTS_SALES_CHANNELS,
  REPORT_EXPORT_SKU_SALES,
} from '../../common/constants/Reports.js'
import {hasMOFeatureSelector} from '../../data/mos.js'
import {showCreateMOModal} from '../MOListPage/Modals/CreateMOModal.js'
import {TAG_TYPE__PRODUCT} from '../../common/constants/Tags.js'
import {showEditTagModal} from '../../common/components/Modal/EditTagModal.js'
import {
  countSelector,
  productListQueryParamsSelector,
} from './productListFunctions.js'
import StocktakeActions from './StocktakeActions.js'
import {reportOptionsByValueSelector} from '../ReportsPage/reportsPageSelectors.js'
import {canUseTransferSelector} from '../../data/transfers.js'

export default function Actions() {
  const hasProductImportFromCartPermission = useSelector(
    hasProductImportFromCartPermissionSelector,
  )
  const hasProductManageTagPermission = useSelector(
    hasProductManageTagPermissionSelector,
  )
  const canUseTransfer = useSelector(canUseTransferSelector)
  const allowCartSyncModal = useSelector(allowCartSyncModalSelector)
  const hasMOFeature = useSelector(hasMOFeatureSelector)
  const hasMOPermission = useSelector(hasMOPermissionSelector)
  const productQuery = useSelector(productListQueryParamsSelector)
  const queryTotalCount = useSelector(countSelector)
  const reportOptionsByValue = useSelector(reportOptionsByValueSelector)

  return (
    <>
      {allowCartSyncModal && hasProductImportFromCartPermission && (
        <li className="inline-block fs-n0 v-align-middle margin-left-15 divider--left">
          <button
            className="btn btn--action v-align-base"
            type="button"
            onClick={() => showCartSyncModal()}
          >
            Import Products
          </button>
        </li>
      )}
      {hasProductManageTagPermission && (
        <li className="inline-block fs-n0 margin-left-15">
          <button
            className="btn btn--action v-align-base"
            onClick={() => showEditTagModal(TAG_TYPE__PRODUCT)}
          >
            Create Tag
          </button>
        </li>
      )}
      <HeaderDropdown
        label="Other Actions"
        className="margin-left-15"
        dropdown="DROPDOWN_PRODUCT_LIST_OTHER_ACTIONS_FOR_SELECTED"
      >
        <li className="list__item list__item--dropdown list__item--dropdown-header">
          <strong>MISC ACTIONS</strong>
        </li>
        {canUseTransfer && (
          <DropdownItemButton
            onClick={() => showCreateInventoryTransferModal()}
          >
            Transfer Inventory
          </DropdownItemButton>
        )}
        <DropdownItemButton onClick={() => showCreateProductModal()}>
          Create a Product
        </DropdownItemButton>
        {hasMOFeature && hasMOPermission && (
          <DropdownItemButton onClick={() => showCreateMOModal()}>
            Initiate a MFG Order
          </DropdownItemButton>
        )}
        {reportOptionsByValue[REPORT_EXPORT_PRODUCTS_INVENTORY] && (
          <DropdownItemButton
            onClick={() =>
              showEditReportModal({
                reportType: REPORT_EXPORT_PRODUCTS_INVENTORY,
                singleRun: true,
                productQuery,
                queryTotalCount,
              })
            }
          >
            {reportOptionsByValue[REPORT_EXPORT_PRODUCTS_INVENTORY].display}
          </DropdownItemButton>
        )}
        {reportOptionsByValue[REPORT_EXPORT_PRODUCTS_NO_INVENTORY] && (
          <DropdownItemButton
            onClick={() =>
              showEditReportModal({
                reportType: REPORT_EXPORT_PRODUCTS_NO_INVENTORY,
                singleRun: true,
                productQuery,
                queryTotalCount,
              })
            }
          >
            {reportOptionsByValue[REPORT_EXPORT_PRODUCTS_NO_INVENTORY].display}
          </DropdownItemButton>
        )}
        {reportOptionsByValue[REPORT_EXPORT_SKU_SALES] && (
          <DropdownItemButton
            onClick={() =>
              showEditReportModal({
                reportType: REPORT_EXPORT_SKU_SALES,
                singleRun: true,
              })
            }
          >
            {reportOptionsByValue[REPORT_EXPORT_SKU_SALES].display}
          </DropdownItemButton>
        )}
        {reportOptionsByValue[REPORT_EXPORT_PRODUCTS_SALES_CHANNELS] && (
          <DropdownItemButton
            onClick={() =>
              showEditReportModal({
                reportType: REPORT_EXPORT_PRODUCTS_SALES_CHANNELS,
                singleRun: true,
                productQuery,
                queryTotalCount,
              })
            }
          >
            {
              reportOptionsByValue[REPORT_EXPORT_PRODUCTS_SALES_CHANNELS]
                .display
            }
          </DropdownItemButton>
        )}
        {reportOptionsByValue[REPORT_EXPORT_PRODUCTS_FULFILLMENT_SPEED] && (
          <DropdownItemButton
            onClick={() =>
              showEditReportModal({
                reportType: REPORT_EXPORT_PRODUCTS_FULFILLMENT_SPEED,
                singleRun: true,
              })
            }
          >
            {
              reportOptionsByValue[REPORT_EXPORT_PRODUCTS_FULFILLMENT_SPEED]
                .display
            }
          </DropdownItemButton>
        )}
        {reportOptionsByValue[REPORT_EXPORT_INVENTORY_SNAPSHOT] && (
          <DropdownItemButton
            onClick={() =>
              showEditReportModal({
                reportType: REPORT_EXPORT_INVENTORY_SNAPSHOT,
                singleRun: true,
              })
            }
          >
            {reportOptionsByValue[REPORT_EXPORT_INVENTORY_SNAPSHOT].display}
          </DropdownItemButton>
        )}
        <StocktakeActions />
      </HeaderDropdown>
    </>
  )
}
